import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { SUPER_ADMIN_EMAIL_DOMAIN, isSuperAdminEmail } from '../../constants/superAdmin';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
  const { usuario, isAuthenticated, logout } = useAuthStore();

  const isSuperAdmin = isSuperAdminEmail(usuario?.email);

  // Force logout if user doesn't have authorized domain (even if already logged in)
  useEffect(() => {
    if (isAuthenticated && usuario && !isSuperAdmin) {
      console.log(`Unauthorized Super Admin access detected. Logging out user:`, {
        email: usuario.email,
        authorizedDomain: SUPER_ADMIN_EMAIL_DOMAIN,
        timestamp: new Date().toISOString()
      });
      
      // Force logout and redirect to login
      logout();
    }
  }, [isAuthenticated, usuario, isSuperAdmin, logout]);

  // Check if user is authenticated
  if (!isAuthenticated || !usuario) {
    return <Navigate to="/login" replace />;
  }

  // Log access attempt for security monitoring
  console.log(`Super Admin access attempt:`, {
    email: usuario.email,
    rol: usuario.rol,
    isAuthorized: isSuperAdmin,
    authorizedDomain: SUPER_ADMIN_EMAIL_DOMAIN,
    timestamp: new Date().toISOString()
  });

  if (!isSuperAdmin) {
    // This should not happen due to useEffect, but as a fallback
    return <Navigate to="/dashboard?error=access_denied" replace />;
  }

  return <>{children}</>;
};
